export const BUYER_INVOICE_LIST_ID = 'buyerInvoicesList';
export const BUYER_DISPUTE_LIST_ID = 'buyerDisputesList';
export const BuyerRecapFCId = 'BuyerRecapFC';
